module.exports = __webpack_public_path__ + "img/icon-phone-outline.d8589bc.svg";